<template>
  <b-modal
    id="modal-bcb-campaign-customer-import"
    :title="!importSuccess ? 'Import khách hàng' : 'Import thành công'"
    :size="!importSuccess ? 'md' : 'xl'"
    centered
    hide-footer
    @hidden="resetModal"
  >
    <b-overlay :show="loading">
      <label>Tải xuống file mẫu:</label>
      <button type="button" @click="downloadTemplate" style="color: #259abb">
        &nbsp;&nbsp;Template_BcbCampaignCustomer.xlsx
      </button>

      <form @submit.prevent="handleSubmit">
        <!-- Upload file -->
        <div v-if="!importSuccess" class="py-4">
          <label>Import file</label>
          <div class="wrap__file mb-1">
            <span class="file__name">
              {{ file ? fileName : 'file import.xlsx' }}
            </span>
            <b-icon-upload
              scale="1.5"
              class="cursor-pointer"
              @click="$refs.fileUpload.click()"
            />
            <input
              v-show="false"
              type="file"
              id="bcb-customer-file-upload"
              ref="fileUpload"
              accept=".xlsx, .xls"
              @change="onUploadFile"
            />
          </div>
          <span v-if="showFileSizeError" class="text-danger">
            Kích thước file import tối đa nhỏ hơn 1MB
          </span>
        </div>

        <!-- Kết quả import -->
        <div v-else>
          <b-row class="mb-4">
            <b-col cols="4" class="d-flex align-items-center">
              <div class="wrap__icon mr-3">
                <i class="fas fa-users text-primary" style="font-size:1.2rem;" />
              </div>
              <div>
                <h6 class="mb-0">Tổng bản ghi</h6>
                <p class="mb-0 font-weight-bold">{{ paging.total }}</p>
              </div>
            </b-col>
            <b-col cols="4" class="d-flex align-items-center">
              <div class="wrap__icon mr-3">
                <i class="fas fa-check-circle text-success" style="font-size:1.2rem;" />
              </div>
              <div>
                <h6 class="mb-0">Thành công</h6>
                <p class="mb-0 font-weight-bold text-success">{{ totalSuccess }}</p>
              </div>
            </b-col>
            <b-col cols="4" class="d-flex align-items-center">
              <div class="wrap__icon mr-3">
                <i class="fas fa-times-circle text-danger" style="font-size:1.2rem;" />
              </div>
              <div>
                <h6 class="mb-0">Thất bại</h6>
                <p class="mb-0 font-weight-bold text-danger">{{ totalFail }}</p>
              </div>
            </b-col>
          </b-row>

          <!-- Result table -->
          <div class="table-responsive">
            <table class="table table-bordered table-sm">
              <thead class="thead-light">
                <tr>
                  <th>STT</th>
                  <th>Họ và tên</th>
                  <th>Số điện thoại</th>
          <th>Email</th>
          <th>Tên phòng khám</th>
          <th>Tên công ty</th>
                  <th>Phòng ban</th>
                  <th class="text-center">Giới tính</th>
                  <th>Ngày sinh</th>
                  <th>Ghi chú</th>
                  <th class="text-center">Trạng thái</th>
                  <th>Chi tiết lỗi</th>
                  <th class="text-center">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in pagedResults" :key="idx">
                  <td>{{ (paging.page - 1) * paging.pageSize + idx + 1 }}</td>
                  <td>{{ item.fullName || '—' }}</td>
                  <td>{{ item.phone || '—' }}</td>
                  <td>{{ item.email || '—' }}</td>
                  <td>{{ item.partnerName || '—' }}</td>
                  <td>{{ item.companyName || '—' }}</td>
                  <td>{{ item.department || '—' }}</td>
                  <td class="text-center">{{ item.gender === 1 ? 'Nam' : item.gender === 0 ? 'Nữ' : '—' }}</td>
                  <td>{{ item.dateOfBirth ? formatDate(item.dateOfBirth) : '—' }}</td>
                  <td>{{ item.noteImport || '—' }}</td>
                  <td class="text-center">
                    <div class="status" :class="item.transactionStatus ? 'active' : 'inactive'">
                      {{ item.transactionStatus ? 'Thành công' : 'Lỗi' }}
                    </div>
                  </td>
                  <td style="min-width:200px;">
                    <template v-if="item.errorMessages && item.errorMessages.length">
                      <div
                        v-for="(err, i) in item.errorMessages"
                        :key="i"
                        class="text-danger"
                        style="font-size:0.82rem;"
                      >- {{ err }}</div>
                    </template>
                    <span v-else-if="!item.transactionStatus" class="text-danger" style="font-size:0.82rem;">Lỗi không xác định</span>
                  </td>
                  <td class="text-center">
                    <div v-if="getCustomerId(item)" class="d-flex justify-content-center">
                      <b-button
                        size="sm"
                        variant="light"
                        class="mr-2"
                        title="Chi tiết khách hàng"
                        @click="viewCustomer(item)"
                      >
                        <i class="fas fa-eye text-primary" />
                      </b-button>
                      <b-button
                        size="sm"
                        variant="danger"
                        :disabled="deletingId === getCustomerId(item)"
                        @click="confirmDeleteCustomer(item)"
                      >
                        <b-spinner v-if="deletingId === getCustomerId(item)" small />
                        <i v-else class="fas fa-trash-alt" />
                      </b-button>
                    </div>
                    <span v-else class="text-muted">—</span>
                  </td>
                </tr>
                <tr v-if="!pagedResults.length">
                  <td colspan="13" class="text-center text-muted py-4">Không có dữ liệu</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="paging.total > paging.pageSize" class="d-flex justify-content-end mt-2">
            <b-pagination
              v-model="paging.page"
              :total-rows="paging.total"
              :per-page="paging.pageSize"
              size="sm"
            />
          </div>
        </div>

        <!-- Footer buttons -->
        <div v-if="!importSuccess" class="d-flex justify-content-end align-items-center mt-4">
          <b-button class="btn mr-2" type="button" @click="onClickCancel">Hủy</b-button>
          <b-button
            class="btn btn-success ml-3"
            type="submit"
            :disabled="disableBtnImport || loading"
          >
            <i class="fas fa-file-import mr-1" />
            Import
          </b-button>
        </div>

        <div v-else class="d-flex justify-content-end mt-4">
          <b-button
            v-if="totalFail > 0"
            class="btn mr-2"
            variant="outline-danger"
            type="button"
            :disabled="loading"
            @click="downloadImportErrors"
          >
            <i class="fas fa-file-excel mr-1" />
            Tải danh sách lỗi
          </b-button>
          <b-button class="btn btn-success" type="button" @click="onClickCancel">Đóng</b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import { EXCEL_FILE_TYPE } from '@/core/plugins/constants';

export default {
  name: 'BcbCampaignCustomerImport',
  props: {
    campaignId: { type: String, default: null },
  },
  data() {
    return {
      loading: false,
      importSuccess: false,
      file: null,
      showFileSizeError: false,
      allResults: [],
      paging: { total: 0, page: 1, pageSize: 10 },
      totalSuccess: 0,
      totalFail: 0,
      deletingId: null,
      // Danh sách khách hàng của chiến dịch
      customers: [],
      customerLoading: false,
      customerPaging: { total: 0, page: 1, pageSize: 10 },
    };
  },
  computed: {
    fileName() {
      return this.file?.name || '';
    },
    disableBtnImport() {
      return !this.file || this.showFileSizeError;
    },
    pagedResults() {
      const { page, pageSize } = this.paging;
      return this.allResults.slice((page - 1) * pageSize, page * pageSize);
    },
  },
  methods: {
    async downloadTemplate() {
      try {
        const response = await this.$api.get(
          '/BcbCampaignCustomer/download-template',
          {
            responseType: 'blob',
            headers: {
              'Content-Type':
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
          },
        );
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Template_BcbCampaignCustomer.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch {
        this.$toastr?.e?.({ title: 'Lỗi', msg: 'Không thể tải file mẫu' });
      }
    },

    onUploadFile(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (!EXCEL_FILE_TYPE.includes(file.type)) {
        this.$refs.fileUpload.value = null;
        this.$toastr?.e?.({ title: 'Lỗi', msg: 'Chỉ hỗ trợ file .xlsx hoặc .xls' });
        return;
      }

      if (file.size > 1024000) {
        this.showFileSizeError = true;
        return;
      }

      this.file = file;
      this.showFileSizeError = false;
    },

    async handleSubmit() {
      if (this.disableBtnImport) return;
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append('importFile', this.file);
        formData.append('campaignId', this.campaignId);

        const { meta, data, error } = await this.$api.post(
          'BcbCampaignCustomer/ImportBcbCampaignCustomers',
          formData,
        );

        if (!meta?.success) {
          this.$toastr?.e?.({ title: 'Lỗi!', msg: error?.message || 'Import thất bại' });
          return;
        }

        // data = { total, totalSuccess, totalFail, data: [...] }
        const rows = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];

        this.allResults = rows.map((el) => ({
          ...el,
          errorMessages: this.parseErrorMessages(el.errorMessage),
        }));
        this.paging.total = data?.total ?? rows.length;
        this.totalSuccess = data?.totalSuccess ?? rows.filter((r) => r.transactionStatus).length;
        this.totalFail = data?.totalFail ?? rows.filter((r) => !r.transactionStatus).length;
        this.paging.page = 1;
        this.importSuccess = true;
      } catch (err) {
        this.$toastr?.e?.({ title: 'Lỗi!', msg: err?.message || 'Import thất bại' });
      } finally {
        this.loading = false;
      }
    },

    parseErrorMessages(text) {
      if (!text) return [];
      return text.split('\n').filter((s) => s.trim());
    },
    async downloadImportErrors() {
      const errorRows = this.allResults.filter((item) => !item.transactionStatus);
      if (!errorRows.length) {
        this.$toastr?.e?.({ title: 'Lỗi', msg: 'Không có dòng lỗi để tải xuống' });
        return;
      }

      try {
        this.loading = true;
        const response = await this.$api.post(
          'BcbCampaignCustomer/export-import-errors',
          errorRows,
          {
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
          },
        );

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'BcbCampaignCustomer_ImportErrors.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        this.$toastr?.e?.({ title: 'Lỗi', msg: err?.message || 'Không thể tải danh sách lỗi' });
      } finally {
        this.loading = false;
      }
    },

    formatDate(val) {
      if (!val) return '—';
      // Hỗ trợ cả Unix timestamp (number) và ISO string
      if (typeof val === 'number') {
        return this.$moment.unix(val).utcOffset('+07:00').format('DD/MM/YYYY');
      }
      return this.$moment(val).format('DD/MM/YYYY');
    },

    resetModal() {
      if (this.importSuccess) {
        this.$emit('import-success');
      }
      this.file = null;
      this.showFileSizeError = false;
      this.importSuccess = false;
      this.allResults = [];
      this.paging = { total: 0, page: 1, pageSize: 10 };
      this.totalSuccess = 0;
      this.totalFail = 0;
      if (this.$refs.fileUpload) this.$refs.fileUpload.value = null;
      this.$emit('reset');
    },

    onClickCancel() {
      this.$bvModal.hide('modal-bcb-campaign-customer-import');
    },

    /**
     * Lấy danh sách khách hàng theo chiến dịch
     * GET /BcbCampaignCustomer/?campaignId={id}
     */
    async loadCampaignCustomers(page = 1) {
      if (!this.campaignId) return;
      try {
        this.customerLoading = true;
        const { meta, data, error } = await this.$api.get('/BcbCampaignCustomer/', {
          params: {
            campaignId: this.campaignId,
            page,
            pageSize: this.customerPaging.pageSize,
          },
        });

        if (!meta?.success) {
          this.$toastr?.e?.({ title: 'Lỗi!', msg: error?.message || 'Không thể tải danh sách khách hàng' });
          return;
        }

        // Hỗ trợ cả hai dạng response: { data: [...], total } hoặc mảng trực tiếp
        this.customers = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        this.customerPaging.total = data?.total ?? this.customers.length;
        this.customerPaging.page = page;
      } catch (err) {
        this.$toastr?.e?.({ title: 'Lỗi!', msg: err?.message || 'Không thể tải danh sách khách hàng' });
      } finally {
        this.customerLoading = false;
      }
    },

    /**
     * Hiển thị hộp thoại xác nhận trước khi xóa
     */
    confirmDeleteCustomer(item) {
      const customerId = this.getCustomerId(item);
      if (!customerId) {
        this.$toastr?.e?.({ title: 'Lỗi!', msg: 'Không tìm thấy ID khách hàng.' });
        return;
      }
      this.$bvModal
        .msgBoxConfirm(
          `Bạn có chắc muốn xóa khách hàng "${item.fullName || item.phone || ''}" không?`,
          {
            title: 'Xác nhận xóa',
            okTitle: 'Xóa',
            cancelTitle: 'Hủy',
            okVariant: 'danger',
            centered: true,
          },
        )
        .then((confirmed) => {
          if (confirmed) this.deleteCustomer(customerId);
        });
    },
    getCustomerId(item) {
      return item?.id || item?.customerId || item?.campaignCustomerId || item?.bcbCampaignCustomerId;
    },
    viewCustomer(item) {
      const customerId = this.getCustomerId(item);
      if (!customerId) {
        this.$toastr?.e?.({ title: 'Lỗi!', msg: 'Không tìm thấy ID khách hàng.' });
        return;
      }
      this.$bvModal.hide('modal-bcb-campaign-customer-import');
      this.$router.push({
        name: 'bcb-campaign-customer-detail',
        params: { campaignId: String(this.campaignId), customerId: String(customerId) },
      });
    },

    /**
     * Xóa khách hàng theo id
     * DELETE /BcbCampaignCustomer/{id}
     */
    async deleteCustomer(id) {
      try {
        this.deletingId = id;
        await this.$api.delete(`/BcbCampaignCustomer/${id}`);

        this.$toastr?.s?.({ title: 'Thành công', msg: 'Đã xóa khách hàng' });

        // Thông báo cho parent reload danh sách sau khi xóa
        this.$emit('import-success');
      } catch (err) {
        this.$toastr?.e?.({ title: 'Lỗi!', msg: err?.message || 'Xóa thất bại' });
      } finally {
        this.deletingId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap__file {
  padding: 10px 16px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:hover {
    border-color: #aaa;
  }

  .file__name {
    color: #5e6278;
    font-size: 0.9rem;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.wrap__icon {
  background: #e4f5f5;
  border-radius: 8px;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  min-width: 90px;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }
}
</style>

<style lang="scss">
#modal-bcb-campaign-customer-import {
  .modal-dialog.modal-xl {
    max-width: 1400px;
  }
}
</style>
